import Vue from 'vue';
import Router from 'vue-router';
import Layout from '../views/Layout.vue';
import NotFound from '../views/404.vue';
import Login from '../views/Login.vue';
import MyLibrary from '../views/personal-center/MyLibrary.vue';
import NewPersonHomeWork from '../views/accompanyStudy/NewPersonHomeWork.vue';
import PersonHomeWorkDetail from '../views/accompanyStudy/PersonHomeWorkDetail.vue';
import TaskHistory from '../views/accompanyStudy/TaskHistory.vue';
import StudentsDraw from '../views/accompanyStudy/StudentsDraw.vue';
import HomeCourseComparision from '../views/homePage/HomeCourseComparision.vue';
import HomeStudentsDraw from '../views/homePage/HomeStudentsDraw.vue';
import StudyTaskRecommend from '../views/books/studyTask/upgraded/StudyTaskRecommend.vue';
import StudyTaskHistory from '../views/books/studyTask/upgraded/StudyTaskHistory.vue';

export const mainRoutes = [
  {
    path: 'homePage',
    name: 'HomePage',
    component: (resolve) =>
      require(['../views/homePage/HomePage.vue'], resolve),
    meta: {
      keepAlive: false,
      isBack: false,
    },
  },
  {
    path: 'books',
    // name: 'Books',
    component: (resolve) => require(['../views/books/Index.vue'], resolve),
    meta: {
      keepAlive: false,
      isBack: false,
    },
    children: [
      {
        path: 'newLessonResources',
        name: 'NewLessonResources',
        component: (resolve) =>
          require(['../views/books/NewLessonResources.vue'], resolve),
      },
      {
        path: 'importantKnowledge',
        name: 'ImportantKnowledge',
        component: (resolve) =>
          require(['../views/books/ImportantKnowledge.vue'], resolve),
      },
      {
        path: '', // 目录
        name: 'Books',
        component: (resolve) =>
          require(['../views/books/IndexContent.vue'], resolve),
      },
      {
        path: 'learning-pre/:id',
        name: 'LearningPre',
        component: (resolve) =>
          require(['../views/books/LearningPre.vue'], resolve),
      },
      {
        path: 'attainment/:id',
        name: 'Attainment',
        component: (resolve) =>
          require(['../views/books/Attainment.vue'], resolve),
      },
      {
        path: 'zhunBei',
        name: 'ZhunBei',
        component: (resolve) =>
          require(['../views/books/studyPrepare/ZhunBei.vue'], resolve),
      },
      {
        path: 'muBiao',
        name: 'MuBiao',
        component: (resolve) => require(['../views/books/MuBiao.vue'], resolve),
      },
      {
        path: 'prepareRecommend', // 学前准备资源推荐
        name: 'PrepareRecommend',
        component: (resolve) =>
          require([
            '../views/books/studyPrepare/PrepareRecommend.vue',
          ], resolve),
      },
      {
        path: 'beiKe',
        name: 'BeiKe',
        component: (resolve) =>
          require(['../views/books/studyPrepare/BeiKe.vue'], resolve),
      },
      {
        path: 'studyTask', // 学习任务--升级2.0
        name: 'StudyTask',
        component: (resolve) =>
          require(['../views/books/studyTask/upgraded/StudyTask.vue'], resolve),
      },
      {
        path: 'taskFeedBack', // 学习任务--任务反馈--升级2.0
        name: 'taskFeedBack',
        component: (resolve) =>
          require([
            '../views/books/studyTask/upgraded/TaskFeedBack.vue',
          ], resolve),
      },
      {
        path: 'studyTaskRecommend', // 学习任务--备课资源
        name: 'StudyTaskRecommend',
        component: (resolve) =>
          require([
            '../views/books/studyTask/upgraded/StudyTaskRecommend.vue',
          ], resolve),
      },
      {
        path: 'studyTaskHistory', // 学习任务--使用记录
        name: 'StudyTaskHistory',
        component: (resolve) =>
          require([
            '../views/books/studyTask/upgraded/StudyTaskHistory.vue',
          ], resolve),
      },
      {
        path: 'textReading', // 课文导读
        name: 'TextReading',
        component: (resolve) =>
          require(['../views/books/textReading/TextReading.vue'], resolve),
      },
      {
        path: 'titleAnalysis', // 标题解析
        name: 'TitleAnalysis',
        component: (resolve) =>
          require(['../views/books/titleAnalysis/TitleAnalysis.vue'], resolve),
      },
      {
        path: 'titleHistory', // 标题解析历史
        name: 'TitleHistory',
        component: (resolve) =>
          require(['../views/books/titleAnalysis/TitleHistory.vue'], resolve),
      },
      {
        path: 'titleRecommend', // 标题解析推荐
        name: 'TitleRecommend',
        component: (resolve) =>
          require(['../views/books/titleAnalysis/TitleRecommend.vue'], resolve),
      },
      {
        path: 'writingGuide', // 写作指导
        name: 'WritingGuide',
        component: (resolve) =>
          require(['../views/books/writingGuide/WritingGuide.vue'], resolve),
      },
      {
        path: 'writingGuideDetail', // 写作指导
        name: 'WritingGuideDetail',
        component: (resolve) =>
          require([
            '../views/books/writingGuide/WritingGuideDetail.vue',
          ], resolve),
      },
      {
        path: 'writingRecommend', // 写作指导推荐资源
        name: 'WritingRecommend',
        component: (resolve) =>
          require([
            '../views/books/writingGuide/WritingRecommend.vue',
          ], resolve),
      },
      {
        path: 'writingHistory', // 写作指导历史
        name: 'WritingHistory',
        component: (resolve) =>
          require(['../views/books/writingGuide/WritingHistory.vue'], resolve),
      },
      {
        path: 'resources', // 资源库
        name: 'Resources',
        component: (resolve) =>
          require(['../views/books/resources/Resources.vue'], resolve),
      },
      {
        path: 'smallClass', // 添加微课
        name: 'SmallClass',
        component: (resolve) =>
          require(['../views/books/smallClass/SmallClass.vue'], resolve),
      },
      {
        path: 'teachThink', // 添加微课
        name: 'TeachThink',
        component: (resolve) =>
          require(['../views/books/teachThink/TeachThink.vue'], resolve),
      },
      {
        path: 'text-read-guide/:id',
        name: 'TextReadGuide',
        component: (resolve) =>
          require(['../views/books/TextReadGuide.vue'], resolve),
      },
      // {
      //   path: 'reading-book/:id',
      //   name: 'ReadingBook',
      //   component: resolve => require(['../views/books/ReadingBook.vue'], resolve)
      // },
      {
        path: 'related-article/:id',
        name: 'RelatedArticle',
        component: (resolve) =>
          require(['../views/books/RelatedArticle.vue'], resolve),
      },
      // {
      //   path: 'excellent-work/:id',
      //   name: 'ExcellentWork',
      //   component: resolve => require(['../views/books/ExcellentWork.vue'], resolve)
      // },
      // {
      //   path: 'writing-guide/:id',
      //   name: 'WritingGuide',
      //   component: resolve => require(['../views/books/WritingGuide.vue'], resolve)
      // },
      // {
      //   path: 'line-label/:id',
      //   name: 'LineLabel',
      //   component: resolve => require(['../views/books/LineLabel.vue'], resolve)
      // },
      // {
      //   path: 'my-participation/:id',
      //   name: 'MyParticipation',
      //   component: resolve => require(['../views/books/MyParticipation.vue'], resolve)
      // },
      // {
      //   path: 'do-task/:id',
      //   name: 'DoTask',
      //   component: resolve => require(['../views/books/DoTask.vue'], resolve)
      // },
      // {
      //   path: 'do-practice/:id',
      //   name: 'DoPractice',
      //   component: resolve => require(['../views/books/DoPractice.vue'], resolve)
      // },
      // {
      //   path: 'active-unit',
      //   name: 'ActiveUnit',
      //   component: resolve => require(['../views/books/ActiveUnit.vue'], resolve)
      // }
    ],
  },
  {
    path: 'groups',
    name: 'Groups',
    component: (resolve) => require(['../views/class/V2/Groups.vue'], resolve),
  },
  {
    path: 'newGroup',
    name: 'newGroup',
    component: (resolve) =>
      require(['../views/class/V2/newGroup.vue'], resolve),
  },
  {
    path: 'class',
    name: 'Class',
    component: (resolve) => require(['../views/class/V2/Index.vue'], resolve),
    // redirect: '/class/chat/:groupid',
    children: [
      {
        path: 'chat',
        name: 'Chat',
        component: (resolve) =>
          require(['../views/class/V2/Chat.vue'], resolve),
      },
      {
        path: 'notice',
        name: 'Notice',
        component: (resolve) =>
          require(['../views/class/V2/Notice.vue'], resolve),
      },
      {
        path: 'member',
        name: 'Member',
        component: (resolve) =>
          require(['../views/class/V2/Member.vue'], resolve),
      },
      {
        path: 'classInfo',
        name: 'ClassInfo',
        component: (resolve) =>
          require(['../views/class/V2/ClassInfo.vue'], resolve),
      },
    ],
  },
  {
    path: 'accompanyStudy',
    name: 'AccompanyStudy',
    component: (resolve) =>
      require(['../views/accompanyStudy/Index.vue'], resolve),
    children: [
      {
        path: 'accompanyStudy',
        name: 'AccompanyStudy',
        component: (resolve) =>
          require(['../views/accompanyStudy/AccompanyStudy.vue'], resolve),
      },
      {
        path: 'correct',
        name: 'Correct',
        component: (resolve) =>
          require(['../views/accompanyStudy/Correct.vue'], resolve),
      },
      {
        path: 'questionSolve',
        name: 'QuestionSolve',
        component: (resolve) =>
          require(['../views/accompanyStudy/QuestionSolve.vue'], resolve),
      },
      {
        path: 'questionToSolve',
        name: 'QuestionToSolve',
        component: (resolve) =>
          require(['../views/accompanyStudy/QuestionToSolve.vue'], resolve),
      },
      {
        path: 'questionToAchive',
        name: 'QuestionToAchive',
        component: (resolve) =>
          require(['../views/accompanyStudy/QuestionToAchive.vue'], resolve),
      },
      {
        path: 'questionAchived',
        name: 'QuestionAchived',
        component: (resolve) =>
          require(['../views/accompanyStudy/QuestionAchived.vue'], resolve),
      },
      // 专家回复模块
      {
        path: 'expertReply',
        name: 'ExpertReply',
        component: (resolve) =>
          require([
            '../views/accompanyStudy/expertReply/ExpertReply.vue',
          ], resolve),
      },
      // 问题归类
      {
        path: 'classifyQuestion',
        name: 'ClassifyQuestion',
        component: (resolve) =>
          require(['../views/accompanyStudy/ClassifyQuestion.vue'], resolve),
      },
      {
        path: 'classifyQuestionDetail',
        name: 'ClassifyQuestionDetail',
        component: (resolve) =>
          require([
            '../views/accompanyStudy/ClassifyQuestionDetail.vue',
          ], resolve),
      },
      {
        path: 'taskHistory',
        name: 'TaskHistory',
        component: (resolve) =>
          require(['../views/accompanyStudy/TaskHistory.vue'], resolve),
      },
      // {
      //   path: 'personHomeWork',
      //   name: 'PersonHomeWork',
      //   component: resolve => require(['../views/accompanyStudy/PersonHomeWork.vue'], resolve)
      // },
      {
        path: 'newPersonHomeWork',
        name: 'NewPersonHomeWork',
        component: NewPersonHomeWork,
        meta: {
          //  keepAlive: true
        },
      },
      {
        path: 'personHomeWorkDetail',
        name: 'PersonHomeWorkDetail',
        component: PersonHomeWorkDetail,
      },
      {
        path: 'newGroupWork',
        name: 'NewGroupWork',
        props: {
          taskType: 'group',
        },
        component: NewPersonHomeWork,
      },
      {
        path: 'studentsExercises',
        name: 'StudentsExercises',
        component: (resolve) =>
          require(['../views/accompanyStudy/StudentsExercises.vue'], resolve),
      },
      {
        path: 'studentsExercisesDetail',
        name: 'StudentsExercisesDetail',
        component: (resolve) =>
          require([
            '../views/accompanyStudy/StudentsExercisesDetail.vue',
          ], resolve),
      },

      {
        path: 'studentsDraw',
        name: 'StudentsDraw',
        component: (resolve) =>
          require(['../views/accompanyStudy/StudentsDraw.vue'], resolve),
      },
      {
        path: 'homeStudentsDraw',
        name: 'HomeStudentsDraw',
        component: (resolve) =>
          require(['../views/homePage/HomeStudentsDraw.vue'], resolve),
      },
      {
        path: 'homeCourseComparison',
        name: 'HomeCourseComparison',
        component: (resolve) =>
          require(['../views/homePage/HomeCourseComparision.vue'], resolve),
      },
      {
        path: 'groupHomeWorkDetail',
        name: 'GroupHomeWorkDetail',
        props: {
          taskType: 'group',
        },
        component: PersonHomeWorkDetail,
      },
      {
        path: 'group',
        name: 'group',
        component: (resolve) => require(['../views/group/Index.vue'], resolve),
        // redirect: '/group/chat/:groupid',
        children: [
          {
            path: 'chat/:groupid',
            name: 'Chat',
            props: {
              type: 'group',
            },
            component: (resolve) =>
              require(['../views/class/Chat.vue'], resolve),
          },
          {
            path: 'notice/:groupid',
            name: 'Notice',
            component: (resolve) =>
              require(['../views/group/Notice.vue'], resolve),
          },
          {
            path: 'member/:groupid',
            name: 'Member',
            component: (resolve) =>
              require(['../views/group/Member.vue'], resolve),
          },
          {
            path: 'classInfo/:groupid',
            name: 'ClassInfo',
            component: (resolve) =>
              require(['../views/group/ClassInfo.vue'], resolve),
          },
        ],
      },
      {
        path: 'class',
        name: 'class',
        component: (resolve) => require(['../views/class/Index.vue'], resolve),
        // redirect: '/class/chat/:groupid',
        children: [
          {
            path: 'chat/:groupid',
            name: 'ChatClass',
            props: {
              type: 'class',
            },
            component: (resolve) =>
              require(['../views/class/Chat.vue'], resolve),
          },
          {
            path: 'notice/:groupid',
            name: 'NoticeClass',
            component: (resolve) =>
              require(['../views/class/Notice.vue'], resolve),
          },
          {
            path: 'member/:groupid',
            name: 'MemberClass',
            component: (resolve) =>
              require(['../views/class/Member.vue'], resolve),
          },
          {
            path: 'classInfo/:groupid',
            name: 'ClassInfoClass',
            component: (resolve) =>
              require(['../views/class/ClassInfo.vue'], resolve),
          },
        ],
      },
      {
        path: 'addGroup/:groupid',
        name: 'AddGroup',
        component: (resolve) =>
          require(['../views/group/AddGroup.vue'], resolve),
        children: [
          {
            path: 'appointGroup/:groupid',
            name: 'AppointGroup',
            component: (resolve) =>
              require(['../views/group/AppointGroup.vue'], resolve),
          },
          {
            path: 'randomGroup/:groupid',
            name: 'RandomGroup',
            component: (resolve) =>
              require(['../views/group/RandomGroup.vue'], resolve),
          },
        ],
      },
    ],
  },
  {
    path: 'famousTeacherRoad',
    name: 'FamousTeacherRoad',
    component: (resolve) =>
      require(['../views/famousTeacherRoad/index.vue'], resolve),
  },
  {
    path: 'newSnailLive',
    name: 'newSnailLive',
    component: (resolve) =>
      require(['../views/famousTeacherRoad/newSnailLive.vue'], resolve),
    meta: {
      data: [
        { title: '名师之路', url: '/newSnailLive' },
        { title: '蜗牛视频', url: '/newSnailLive' },
      ],
    },
  },
  {
    path: 'snailLiveNow',
    name: 'snailLiveNow',
    component: (resolve) =>
      require(['../views/famousTeacherRoad/snailLiveNow.vue'], resolve),
    meta: { data: [{ title: '蜗牛视频', url: '/newSnailLive' }] },
  },
  {
    path: 'snailVideoList',
    name: 'snailVideoList',
    component: (resolve) =>
      require(['../views/famousTeacherRoad/snailVideoList.vue'], resolve),
    meta: {
      data: [
        { title: '名师之路', url: '/snailVideoList' },
        { title: '蜗牛视频', url: '/snailVideoList' },
      ],
    },
  },
  {
    path: 'chatRoom',
    name: 'chatRoom',
    component: (resolve) =>
      require(['../views/famousTeacherRoad/chatRoom.vue'], resolve),
  },
  {
    path: 'myPublish',
    name: 'myPublish',
    component: (resolve) =>
      require(['../views/famousTeacherRoad/myPublish.vue'], resolve),
    meta: {
      data: [
        { title: '名师之路', url: '/myComment' },
        { title: '交流广场', url: '/myComment' },
        { title: '我发布的', url: '' },
      ],
    },
  },
  // 蜗牛文章
  {
    path: 'snailBookNew',
    name: 'snailBookNew',
    component: (resolve) =>
      require(['../views/famousTeacherRoad/snailBookNew.vue'], resolve),
    meta: {
      data: [
        { title: '名师之路', url: '/snailBookList' },
        { title: '蜗牛文章', url: '/snailBookList' },
      ],
    },
    children: [
      {
        path: '/snailBookList',
        name: 'snailBookList',
        component: (resolve) =>
          require(['../views/famousTeacherRoad/snailBookList.vue'], resolve),
        meta: {
          data: [
            { title: '名师之路', url: '/snailBookList' },
            { title: '蜗牛文章', url: '/snailBookList' },
          ],
        },
      },
      {
        path: '/mySnailBookList',
        name: 'mySnailBookList',
        component: (resolve) =>
          require(['../views/famousTeacherRoad/mySnailBookList.vue'], resolve),
        meta: {
          data: [
            { title: '名师之路', url: '/mySnailBookList' },
            { title: '蜗牛文章', url: '/mySnailBookList' },
          ],
        },
      },
      {
        path: '/snailBookListDetail',
        name: 'snailBookListDetail',
        component: (resolve) =>
          require([
            '../views/famousTeacherRoad/snailBookListDetail.vue',
          ], resolve),
        meta: {
          data: [
            { title: '蜗牛文章', url: '/snailBookList' },
            { title: '全部文章', url: '/snailBookListDetail' },
          ],
        },
      },
    ],
  },
  {
    path: 'writeBook',
    name: 'writeBook',
    component: (resolve) =>
      require(['../views/famousTeacherRoad/writeBook.vue'], resolve),
  },
  {
    path: 'snailVideoDetail',
    name: 'snailVideoDetail',
    component: (resolve) =>
      require(['../views/famousTeacherRoad/snailVideoDetail.vue'], resolve),
    meta: { data: [{ title: '蜗牛视频', url: '/newSnailLive' }] },
  },
  // 交流空间
  {
    path: 'myComment',
    name: 'myComment',
    component: (resolve) =>
      require(['../views/famousTeacherRoad/myComment.vue'], resolve),
    meta: {
      data: [
        { title: '名师之路', url: '/chatRoom' },
        { title: '交流广场', url: '/chatRoom' },
        { title: '我的评论', url: '' },
      ],
    },
  },
  {
    path: 'gaokaoRealExam',
    name: 'GaokaoRealExam',
    component: (resolve) =>
      require(['../views/examHall/GaokaoRealExam.vue'], resolve),
  },
  {
    path: 'personal-center',
    name: 'PersonalCenter',
    component: (resolve) =>
      require(['../views/personal-center/Index.vue'], resolve),
    redirect: { name: MyLibrary.name },
    children: [
      {
        path: 'my-info',
        name: 'MyInfo',
        component: (resolve) =>
          require(['../views/personal-center/MyInfo.vue'], resolve),
      },
      {
        path: 'my-password',
        name: 'MyPassWord',
        component: (resolve) =>
          require(['../views/personal-center/MyPassWord.vue'], resolve),
      },
      {
        path: 'my-books',
        name: 'MyBooks',
        component: (resolve) =>
          require(['../views/personal-center/MyBooks.vue'], resolve),
      },
      {
        path: 'buy-books',
        name: 'BuyBook',
        component: (resolve) =>
          require(['../views/personal-center/BuyBook.vue'], resolve),
      },
      {
        path: 'my-credis',
        name: 'MyCredits',
        component: (resolve) =>
          require(['../views/personal-center/MyCredits.vue'], resolve),
      },
      {
        path: 'my-history',
        name: 'MyHistory',
        component: (resolve) =>
          require(['../views/personal-center/MyHistory.vue'], resolve),
      },
      {
        path: 'my-library',
        name: 'MyLibrary',
        component: (resolve) =>
          require(['../views/personal-center/MyLibrary.vue'], resolve),
      },
      {
        path: 'my-order',
        name: 'MyOrder',
        component: (resolve) =>
          require(['../views/personal-center/MyOrder.vue'], resolve),
      },
      {
        path: 'my-shareList',
        name: 'MyShareList',
        component: (resolve) =>
          require(['../views/personal-center/MyShareList.vue'], resolve),
      },
    ],
  },
  {
    path: 'notification',
    name: 'Notification',
    component: (resolve) =>
      require(['../views/notification/Index.vue'], resolve),
  },
  {
    path: 'download',
    name: 'Download',
    component: (resolve) => require(['../views/download/Index.vue'], resolve),
  },
];

const getRoutes = (getUserInfo) => {
  return [
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/',
      name: 'Layout',
      component: Layout,
      redirect: mainRoutes[0],
      children: mainRoutes,
      // beforeRouteLeave (to, from, next){
      //   if(to.meta){
      //     to.meta.keepAlive = true
      //     if(this.reload){
      //       to.meta.keepAlive = false
      //     }
      //   }
      //   next()
      // },
      beforeEnter: (to, from, next) => {
        const userInfo = JSON.parse(localStorage.getItem('user_info'));
        if (userInfo) {
          // ROLE_LEARNER_ENT 学生 ROLE_TEACHER_ENT 老师
          const roleType = userInfo.roleList.find((item) => {
            return item.roleName === 'ROLE_TEACHER_ENT';
          });
          if (roleType) {
            // 跳转教师端
            next();
          } else {
            // alert('请使用教师账号访问')
            // const baseUrl = this.$studentUrl.replace(/\/$/, '')
            // window.location.href = roleType ? baseUrl + '/tea1/#/homePage' : baseUrl + '/stu1/#/books'
            // 跳转学生端（路由守卫内无 Vue 实例，不可用 this.$xxx）
            window.location.href = process.env.VUE_APP_Login_student_url;
            // next({ name: 'Login' })
            // if (process.env.NODE_ENV === 'production') {
            //   window.location.replace('https://www.e-snails.com/')
            // } else {
            //   window.location.replace('http://192.168.6.111:81/tea1/#/login')
            // }
          }
        } else {
          // next({ name: 'Login' })
          alert(
            '检测到账号身份变更。为了数据安全，当前登录会话已失效。如需同时使用不同角色，请使用浏览器的‘无痕模式’或更换浏览器。',
          );
          // if (process.env.NODE_ENV === 'production') {
          //   window.location.replace('https://www.e-snails.com/')
          // } else {
          //   window.location.replace('http://192.168.6.111:81/tea1/#/login')
          // }
          // const baseUrl = this.$studentUrl.replace(/\/$/, '')
          window.location.href = process.env.VUE_APP_Login_url;
          window.location.reload();
        }
      },
    },
    {
      // 移动端-学生画像地址
      path: '/studentsDraw/:parameter',
      name: 'PhoneStudentsDraw',
      component: HomeStudentsDraw,
    },
    {
      path: '/HomeCourseComparision/:parameter',
      name: 'PhoneCourseComparision',
      props: {
        params: '',
      },
      component: HomeCourseComparision,
    },
    {
      path: '/newPersonHomeWork/:parameter',
      name: 'NewPersonHomeWork',
      component: NewPersonHomeWork,
    },
    {
      path: '/personHomeWorkDetail/:parameter',
      name: 'PersonHomeWorkDetail',
      component: PersonHomeWorkDetail,
    },
    {
      path: '/newGroupWork/:parameter',
      name: 'NewGroupWork',
      props: {
        taskType: 'group',
      },
      component: NewPersonHomeWork,
    },
    {
      path: '/groupHomeWorkDetail/:parameter',
      name: 'GroupHomeWorkDetail',
      props: {
        taskType: 'group',
      },
      component: PersonHomeWorkDetail,
    },
    // {
    //   path: '/studentsDraw/:parameter',
    //   name: 'StudentsDraw',
    //   component: StudentsDraw
    // },
    {
      path: '/studentsExercises/:parameter',
      name: 'StudentsExercises',
      component: (resolve) =>
        require(['../views/accompanyStudy/StudentsExercises.vue'], resolve),
    },
    {
      path: '/studentsExercisesDetail/:parameter',
      name: 'StudentsExercisesDetail',
      component: (resolve) =>
        require([
          '../views/accompanyStudy/StudentsExercisesDetail.vue',
        ], resolve),
    },
    {
      path: '/taskHistory/:parameter',
      name: 'App-TaskHistory',
      component: TaskHistory,
    },
    {
      path: '/studyTaskRecommend', // 学习任务--备课资源
      name: 'StudyTaskRecommend',
      component: StudyTaskRecommend,
    },
    {
      path: '/studyTaskHistory', // 学习任务--使用记录
      name: 'StudyTaskHistory',
      component: StudyTaskHistory,
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
    },
  ];
};

const route = ({ getUserInfo }) => {
  Vue.use(Router);
  return new Router({
    // mode: 'history',
    routes: getRoutes(getUserInfo),
  });
};

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default route;
